import React, { useEffect, useRef, useState } from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js';
import { Tooltip } from 'recharts'
import Stripe from 'stripe';

import { API,STRIPEPUBLICKEY,STRIPESECRETKEY } from '../../../backend';
import ExitingCheckout from './addUserCheckout';
import Helper from '../../../Helper';

const AddExitingPayment = ({ userallowed, companyid, planData, companydata, setAdduser, setCompany, setUpgrade, adduser, upgrade, value,paymentid,end_date }) => {
    const [clientSecret, setClientSecret] = useState("");
    const [userallows, setUserallows] = useState(1)
    const [amount, setAmount] = useState(0)
    const [userdata, setUserData] = useState(false)
    const [paymentintentid, setPaymentIntentID] = useState('');
    const [name, setName] = useState(companydata.name);
    const [email, setEmail] = useState(companydata.user_email);
    const [company_name, setCompnayName] = useState(companydata.company_name);
    const [address, setAddress] = useState(companydata.address);
    const [city, setCity] = useState(companydata.city);
    const [zip_code, setZipCode] = useState(companydata.zip_code);
    const [phone_number, setPhoneNumber] = useState(companydata.phone_number);
    const [country, setCountryid] = useState(companydata.country);
    const [state, setStateid] = useState(companydata.country);
    const [isLoading, setIsLoading] = useState(false)
    const [start_date, setStart_date] = useState('')
    // const [end_date, setEnd_date] = useState('')
    const fetchCalled = useRef(false);
    const stripePromise = loadStripe(
        STRIPEPUBLICKEY
    );
  
    const options = { clientSecret };
    const stripe = Stripe(
        STRIPESECRETKEY
    );


    const fetchClientSecret = async () => {
        if (!fetchCalled.current) {
            fetchCalled.current = true;
            try {
                const amounts = 1 * 100 * 12
                const plan = planData.map((val) => val.plan)
                if (amounts !== null) {
                    const response = await fetch(API + 'accounting/create-payment-intent/', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            items: ['item1', 'item2'],
                            amount: amounts,
                            plan: 'Annual'
                        }),
                    });

                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }

                    const data = await response.json();
                    setClientSecret(data.clientSecret);
                    setPaymentIntentID(data.intent_id.id);
                }
            } catch (error) {
                console.error("Error fetching client secret:", error);
            }
        }
    };
    
    useEffect(() => {
        fetchClientSecret()
    }, [])

    useEffect(() => {
        const currentDate = new Date(); // Get the current date

        const futureEndDate = new Date(currentDate); // Create a new date object for end date (set to start date)
        futureEndDate.setFullYear(currentDate.getFullYear() + 1); // Set end date 1 year from the start date

        const startDate = Helper.DatePicker(currentDate);
        const endDate = Helper.DatePicker(futureEndDate);

        setStart_date(startDate); // Update start_date state with the future start date
        // setEnd_date(endDate); // Update end_date state with the future end date
    }, []);


    useEffect(() => {
        const currentDate = new Date(); 
        const endDate = new Date(end_date);
        
        const diffInMonths = (endDate.getFullYear() - currentDate.getFullYear()) * 12 + (endDate.getMonth() - currentDate.getMonth());
        
        const monthlyPayment = 1200;
        const remainingPayment = monthlyPayment * diffInMonths / 12 * userallows;
        
        setAmount(remainingPayment);
    }, [planData, userallows, end_date]);
    
    return (
        <div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-sm-6">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div className="col-md-6">
                                        <label className="col-form-label required">
                                            Users
                                            <Tooltip content={"User Allow"}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                        <input
                                            type="number"
                                            min='1'
                                            value={userallows}
                                            className="form-control"
                                            placeholder="No of user"
                                            name="userAllow"
                                            onChange={(e) => {
                                                const newValue = Math.max(1, parseInt(e.target.value, 10)) || '';
                                                setUserallows(newValue);
                                            }}
                                        />
                                    </div>
                                    <span style={{ marginTop: '1rem' }}>Total Amount : $ {amount}</span>
                                    <div id="checkout " style={{ marginTop: '1rem' }}>
                                        {clientSecret && (
                                            <Elements stripe={stripePromise} options={{ clientSecret }}
                                            >

                                                <ExitingCheckout
                                                    setIsLoading={setIsLoading}
                                                    isLoading={isLoading}
                                                    userData={setUserData}
                                                    setCompany={setCompany}
                                                    paymentintentid={paymentintentid}
                                                    companydata={companydata}
                                                    companyid={companyid}
                                                    company_name={company_name}
                                                    name={name}
                                                    email={email}
                                                    phone_number={phone_number}
                                                    address={address}
                                                    country={country}
                                                    state={state}
                                                    city={city}
                                                    zip_code={zip_code}
                                                    userAllow={userallows}
                                                    userallowed={userallowed}
                                                    amount={amount}
                                                    start_date={start_date}
                                                    end_date={end_date}
                                                    setAdduser={setAdduser}
                                                    setUpgrade={setUpgrade}
                                                    adduser={adduser}
                                                    upgrade={upgrade}
                                                    value={value}
                                                    paymentid={paymentid}
                                                />
                                            </Elements>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default AddExitingPayment